import type { $ } from "../../../dom";
import type { InputWithItemValue } from "../../core";
import { CheckboxInput, type CheckboxInputOptions } from "../base";

export type SimpleCheckboxInputOptions = Omit<
  CheckboxInputOptions<string | null>,
  "resetValue"
>;

export class SimpleCheckboxInput
  extends CheckboxInput<string | null>
  implements InputWithItemValue<string | null>
{
  constructor($root: $, options: SimpleCheckboxInputOptions = {}) {
    const { ...superOptions } = options;

    super($root, {
      resetValue: null,
      $findInput:
        superOptions.$findInput ??
        (($root) => $root.find("input[type='checkbox']", true)),
      ...superOptions,
    });
  }

  private getItemText(): string {
    return this.$root.text;
  }

  getItemValue(): string {
    return this.$root.rk("value") || this.getItemText();
  }

  get value(): string | null {
    return this.isActive ? this.getItemValue() : null;
  }

  set value(value: string | null) {
    this.isActive = value === this.getItemValue();
  }

  get data(): string | null {
    return this.isActive ? this.getItemText() : null;
  }
}
